<template>
  <div class="slider__card">
    <img src="~@/assets/images/slider-item-imgs/img044.png" alt="img044.png">
    <div class="text-container">
      <text-string label-id="txt1438"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "storage-instruction-cover"
  }
</script>
